module.exports = __webpack_public_path__ + "img/marketing.8b1875ae.jpg";